import { useEffect, useCallback } from 'react';
import './style.scoped.css';
import { sendOpenNewWebview } from 'src/utils';
import Loading from 'src/components/Loading';
import usePullToRefresh from 'src/hooks/usePullToRefresh';
import Product from 'src/models/Product';
import ProductOnline from 'src/models/ProductOnline';
import { ProductCode } from 'src/constants';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ProductTabContentProps {
  title: string;
  loadAction: () => Promise<void>;
  productList: Product[] | ProductOnline[];
  loading: boolean;
}

const ProductTabContent = (props: ProductTabContentProps) => {
  const { loadAction, productList, loading, title } = props;
  const history = useHistory();
  const { t } = useTranslation();

  const _load = useCallback(() => {
    loadAction();
  }, [loadAction]);

  // Add pull to refresh function
  usePullToRefresh('.refreshContent', <Loading type={'small'} />, _load);

  useEffect(() => {
    _load();
  }, [_load]);

  const _handlePressItem = useCallback(
    (item) => {
      console.log('Item', JSON.parse(JSON.stringify(item)));
      if (item?.productCode == ProductCode.SPA) {
        history.push('/spa_insurrance_info');
      } else if (item?.productCode == ProductCode.CANCER) {
        history.push('/buy-insurance/cancer/product-info');
      } else {
        sendOpenNewWebview(item);
      }
    },
    [history]
  );

  const _renderItem = (item, index) => {
    return (
      <img
        className={`item`}
        src={item.photo}
        onClick={() => _handlePressItem(item)}
        key={item.id}
      />
    );
  };

  const numOfCol = 2;
  const numOfRow =
    productList && productList.length > 0
      ? Math.ceil(productList.length / numOfCol)
      : 1;

  return (
    <div className="roundContent">
      <div>
        <div className="blockTitle2 text-onSurface mb-4">{title}</div>
        <div className="screenScrollContainerWithTabAndTitle refreshContent">
          {loading ? (
            <Loading type={'small'} />
          ) : !productList || productList.length == 0 ? (
            <div className="center p-4 pt-8">
              <div className="text-center text-onSurfaceVariant">
                {t('no_product')}
              </div>
            </div>
          ) : (
            <div
              className={`grid grid-flow-row grid-cols-${numOfCol} grid-rows-${numOfRow} gap-3`}
            >
              {productList.map(_renderItem)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductTabContent;
